<template>
    <div class="HomeLogado">
        <HeaderLogado></HeaderLogado>
        <BoxPesquisa></BoxPesquisa>

     
        <div class="">
            <div class="container pt-4 mb-4">
                <div class="row">
                    <div class="col-12">
                        <span class="txt-p txt-roxo-1 txt-w-bold txt-size-16 c-pointer" @click="voltar"><i class="fas fa-arrow-left"></i> Voltar para resultados</span>
                    </div>
                </div>


            </div>
            <div class="container" v-if="pergunta != null">
                <div class="row">
                    <!--<div class="col-12">
                        <span class="txt-p txt-cores-6 txt-w-5 txt-size-20">Pergunta nº {{id}}</span>
                    </div>-->                    
                    <div class="col-10 d-flex align-items-center">
                        <div>
                            <span class="txt-p txt-cores-6 txt-w-bold txt-size-18">{{pergunta.dsAssunto}}</span>
                        </div>
                    </div>
                    <div class="col-2 d-flex align-items-center">
                        <div>
                            <span class="txt-p txt-cores-6 txt-w-5 txt-size-16">Modalidade</span>
                            <p class="txt-p txt-cores-1 txt-w-5 txt-size-16"> <i :class="pergunta.tipoPergunta.icone"></i> {{pergunta.tipoPergunta.nmTipoPergunta}}</p>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="box-borda-cinza mb-5">
                            <!--<p class="txt-p txt-w-bold txt-cores-6">Pergunta</p>-->
                            <div class="dsEmenta txt-p txt-size-16 txt-cores-1" v-html="pergunta.dsEmenta"></div>

                            <div class="pdf mt-5" id="pdf-pesquisa" v-if="pergunta.urlArquivo">
                                VISUALIZADOR DE PDF
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row  mb-4" v-else>
                <div class="col-12 text-center my-5">
                    <p class="txt-p txt-roxo-1 txt-w-5 txt-size-18">Pergunta não encontrada!</p>
                </div>
            </div>

        </div>

        <Footer></Footer>
    </div>
</template>

<script>
    import HeaderLogado from '@/components/HeaderLogado'
    import Footer from '@/components/Footer'
    import BoxPesquisa from '@/components/Pesquisa'

    import { urlApi, avisoErro } from '@/config/global'
    import axios from 'axios'

    export default {
        name: 'DetalhePesquisa',
        components: { HeaderLogado, Footer, BoxPesquisa },
        props: ['id'],
        data: function () {
            return {
                pergunta: null,
               
            }
        },
        
        methods: {

            voltar() {
                this.$router.go(-1)
            },

            load() {
                let $this = this;                
                axios.get(`${urlApi}/Pergunta/DetalhePesquisa/${$this.id}`, { showLoading: false })
                    .then(res => {
                        if (res.data.success) {
                            $this.pergunta = res.data.data;
                            if ($this.pergunta.idOrientacao != 0) {
                                this.$nextTick(function () {
                                    // eslint-disable-next-line
                                    PDFObject.embed($this.pergunta.urlArquivo, "#pdf-pesquisa");
                                    //PDFObject.embed("https://sollicita.s3.sa-east-1.amazonaws.com/NP/SollicitaAdmin/Content/ConteudoDinamico/ArquivosOrientacaoPesquisa/vfffniyRO108ago2021_RO108ago2021_Ata_de_Registro_de_Precos_Verificacao_da_manutencao_das_condicoes_de_habilitacao_para_a_assinatura_da_ARP.pdf?X-Amz-Expires=120&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAZQDDPQRJ5LVS6SFC/20211213/sa-east-1/s3/aws4_request&X-Amz-Date=20211213T140559Z&X-Amz-SignedHeaders=host&X-Amz-Signature=d47dbc27b73ee31934a7256d85320ba47906d170f587af26a33c89d12ba4ccaa", "#pdf-pesquisa");
                                });
                                
                                if ($this.pergunta.tpOrientacao == "PA") {
                                    $this.pergunta.tipoPergunta = {
                                        nmTipoPergunta: "Estudo Técnico",
                                        icone: "fas fa-clipboard-list"
                                    };
                                    
                                } else {
                                    $this.pergunta.tipoPergunta = {
                                        nmTipoPergunta: "Resposta Objetiva",
                                        icone: "far fa-clock"
                                    };
                                }
                            } else {
                                $this.pergunta = null;
                            }
                            
                            
                        } else {
                            avisoErro("Não foi possível carregar a pergunta.");
                        }

                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                    });
            },

        },
        mounted: function () {
            this.load();
            
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" >
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .HomeLogado {
        background-color: #E5E5E5;
    }


    .pdf{
        height: 600px;
    } 
</style>

